import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import JSONtoReportData from '../json-to-chartdata/JSONtoReportData';
import LoadingOverlay from 'react-loading-overlay';
import { REPORT_TYPE_SET } from '../../../config/ReportOptionSet';
import { Channel_CODE_SET } from '../../../config/CgmCodeSet';
import { getExpressParams, deleteExpressParams } from '../../../service/api';
import SnapshotManagerMain from '../../presentation/section/snapshot-manager-page/SnapshotManagerMain';
import AlertModal from '../../presentation/modal/AlertModal';


const SnapshotManager = (props) => {
  const [selectedSnapshot, setSelectedSnapshot] = useState({
    snapshotID: null,
    content: null,
    name: null,
    subQueryType: null,
    reportType: [],
    label: null
  });

  const [selectedSnapshotQuery, setSelectedSnapshotQuery] = useState({
    mainQuery: null,
    subQuery: []
  });

  const [snapshotLabelData, setSnapshotLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  });

  const [snapshotFilter, setSnapshotFilter] = useState('');

  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  });

  const [queryData, setQueryData] = useState(null)

  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);

  const [options, setOptions] = useState({
    timeunit: 'daily',
    datatype: 'numeric',
    rows: '50',
    words: '200',
    morph: 'all',
  })

  const [volumeResult, setVolumeResult] = useState(null);
  const [sentimentResult, setSentimentResult] = useState(null);
  const [sourceResult, setSourceResult] = useState(null);
  const [relationResult, setRelationResult] = useState(null);
  const [categoryResult, setCategoryResult] = useState(null);
  const [positioningmapResult, setPositioningmapResult] = useState(null);
  const [userRole, setUserRole] = useState('')

  const [alertShow, setAlertShow] = useState(false);
  const handleAlertShow = () => setAlertShow(true);
  const handleAlertClose = () => setAlertShow(false);

  useEffect(()=>{
    getExpressParams('/query/snapshot-label/userid/all', {
      email: props.currentUser  
    }, (response) => {
      setSnapshotLabelData(MakeLabelTreeData(response.data.snapshotentity, response.data.BuzzLabel))
      setQueryData(response.data.queryentity);        
    })
    getExpressParams('/users/role/userid', {
      email: props.currentUser
    }, (response) => {
      setUserRole(response.data[0].role)
    })
  }, [])

  useEffect(()=>{
    handleSearchBtn(JSON.stringify(snapshotLabelData));
  }, [snapshotLabelData])

  useEffect(()=>{
    setVolumeResult(null);
    setSentimentResult(null);
    setSourceResult(null);
    setRelationResult(null);
    setCategoryResult(null);
    setPositioningmapResult(null);
  }, [selectedSnapshot])

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>!snapshotFilter || item.name.toLowerCase().startsWith(snapshotFilter.toLowerCase()));

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((snapshotItem)=> !snapshotFilter || snapshotItem.name.toLowerCase().startsWith(snapshotFilter.toLowerCase()));
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    setFilteredArray(tempArray);
    setVolumeResult(null);
    setSentimentResult(null);
    setSourceResult(null);
    setRelationResult(null);
    setCategoryResult(null);
    setPositioningmapResult(null);
  }

  const handleSearchInput = (event) => {
    setSnapshotFilter(event.target.value);
  }


  const handleRunBtn = () => {
    setVolumeResult(null);
    setSentimentResult(null);
    setSourceResult(null);
    setRelationResult(null);
    setCategoryResult(null);
    setPositioningmapResult(null);

    let jsonQueryArray = [];

    jsonQueryArray.push({
      "name": queryData.info.filter(query=>query.queryID===selectedSnapshotQuery.mainQuery)[0].name,
      "type": queryData.info.filter(query=>query.queryID===selectedSnapshotQuery.mainQuery)[0].QUERY_TYPE,
      "content": JSON.parse(queryData.info.filter(query=>query.queryID===selectedSnapshotQuery.mainQuery)[0].content)
    })

    selectedSnapshotQuery.subQuery.forEach((item)=>{
      jsonQueryArray.push({
        "name": queryData.info.filter(query=>query.queryID===item.queryID)[0].name,
        "type": queryData.info.filter(query=>query.queryID===item.queryID)[0].QUERY_TYPE,
        "content": JSON.parse(queryData.info.filter(query=>query.queryID===item.queryID)[0].content)
      })
    })

    setLoaded(false);
    handleLoadingText();

    let count = 0;
    JSON.parse(selectedSnapshot.REPORT_TYPE).forEach(reportTypeItem=>{
      count++;

      getExpressParams(`/report/${reportTypeItem}/json`, {
        email: props.currentUser,
        json: {
          "channel": JSON.parse(selectedSnapshot.content).channels,
          "dateRange": JSON.parse(selectedSnapshot.content).date,
          "name": selectedSnapshot.name,
          "query": jsonQueryArray,
          "reportType": reportTypeItem,
          "retwit": JSON.parse(selectedSnapshot.content).reTweet,
          "sub_query_type": selectedSnapshot.function,
          "morph": JSON.parse(selectedSnapshot.content).morph
        }
      }, (response) => {
        count--;
        if( count ==0 ) {
          setLoaded(true)
          setLoadingText(<div>loadng</div>)
        }
        if(response.data.success){
          switch(reportTypeItem){
            case "volume": {
              setVolumeResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "sentiment": {
              setSentimentResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "source": {
              setSourceResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "relation": {
              setRelationResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "category": {
              setCategoryResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            case "positioningmap": {
              setPositioningmapResult(JSONtoReportData(response.data.report_data, options));
              break;
            }
            default:
              break;
          }
        }
        else{
          handleAlertShow();
        }
      })
    })
  }

  const handleRemoveBtn = (snapshotID) => {
    deleteExpressParams(`/query/snapshot-content/snapshotid`, {
      email: props.currentUser,
      snapshotID: snapshotID
    }, (response) => {
      setSnapshotLabelData({
        type: null,
        name: null,
        info: [],
        nullLabelItem: [],
        nullLabelItemType: null,
      });
      setSnapshotLabelData(MakeLabelTreeData(response.data.snapshotentity, response.data.BuzzLabel));
      setSelectedSnapshot({
        snapshotID: null,
        content: null,
        name: null,
        subQueryType: null,
        reportType: null,
        label: null
      })
      setSelectedSnapshotQuery({
        mainQuery: null,
        subQuery: []
      })
      setVolumeResult(null);
      setSentimentResult(null);
      setSourceResult(null);
      setRelationResult(null);
      setCategoryResult(null);
      setPositioningmapResult(null);
    })
  }

  const handleSelectedSnapshot = (snapshotInfo) => {
    setSelectedSnapshot(snapshotInfo);
    // setVolumeResult(null);
    // setSentimentResult(null);
    // setSourceResult(null);
    // setRelationResult(null);
    // setCategoryResult(null);
    // setPositioningmapResult(null);

    getExpressParams('/query/snapshot-content/userid/snapshotid', {
      email: props.currentUser,
      snapshotID: snapshotInfo.snapshotID
    }, (response) => {
      setSelectedSnapshotQuery({
        mainQuery: response.data.basequery,
        subQuery: response.data.subquery
      })
    })
  }

  const MakeLabelTreeData = (nodeData, labelData) => {

    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  const handleLoadingText = () => {
    let outputBaseQuery = queryData.info.find(item=>item.queryID==selectedSnapshotQuery.mainQuery).name;
    let outputSubQuery = [];
    selectedSnapshotQuery.subQuery.forEach(subQueryItem=>{
      outputSubQuery.push(queryData.info.find(item=>item.queryID==subQueryItem.queryID).name)
    });
    let outputChannel = [];
    JSON.parse(selectedSnapshot.content).channels.forEach(channelItem=>{
      outputChannel.push(Channel_CODE_SET[channelItem])
    })

    setLoadingText(
    <span style={{textAlign: "left"}}>
      <div>
        Date: {`${JSON.parse(selectedSnapshot.content).date[0]} ~ ${JSON.parse(selectedSnapshot.content).date[1]}`}
      </div>
      <div>
        BaseKeyword: {outputBaseQuery}
      </div>
      {outputSubQuery.length != 0 ?
      <>
        <div>
          SubKeyword: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div>
        <div>
          SubKeywordType: {selectedSnapshot.function=="compare"? "비교" : "교차"}
        </div>
      </>
      :undefined}
      <div>
        Channel: {outputChannel.map((item,index)=>{
            if (index==outputChannel.length-1){
              return (`${item}`)
            } 
            else return (`${item}, `)        
        })}
      </div>
      <div>
        Snapshot Type: {JSON.parse(selectedSnapshot.REPORT_TYPE).map((item,index) => {
          if (index==JSON.parse(selectedSnapshot.REPORT_TYPE).length-1){
            return(`${REPORT_TYPE_SET[item]}`)
          } 
          else return(`${REPORT_TYPE_SET[item]}, `)
        })}
      </div>
      {/* <div>
        Snapshot Type: {REPORT_TYPE_SET[selectedSnapshot.REPORT_TYPE]}
      </div> */}
    </span>
    )
  }


  return (
    <>
      <AlertModal alertShow={alertShow} handleAlertClose={handleAlertClose} handleAlertShow={handleAlertShow} />
      <LoadingOverlay
        active={!loaded}
        spinner={true}
        text={loadingText}>
          <SnapshotManagerMain snapshotLabelData={snapshotLabelData} selectedSnapshot={selectedSnapshot} handleSelectedSnapshot={handleSelectedSnapshot} handleSearchBtn={handleSearchBtn} snapshotFilter={snapshotFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray}
            queryData={queryData} handleRemoveBtn={handleRemoveBtn} handleRunBtn={handleRunBtn} volumeResult={volumeResult} sentimentResult={sentimentResult} sourceResult={sourceResult} categoryResult={categoryResult} relationResult={relationResult} positioningmapResult={positioningmapResult} options={options} selectedSnapshotQuery={selectedSnapshotQuery}
            userRole={userRole}
          />
      </LoadingOverlay>
    </>
  )
}

const mapStateToProps = (state) => ({
    currentUser: state.AuthManager.status.currentUser
});

export default connect(mapStateToProps) (SnapshotManager);  